module.exports = __webpack_public_path__ + "music.f51d6ba788a6d0de8066.svg";


//////////////////
// WEBPACK FOOTER
// C:/Users/INMOGR/Desktop/Angular Project/src/assets/fonts/line-icons-pro/music/webfont/music.svg
// module id = ../../../../../src/assets/fonts/line-icons-pro/music/webfont/music.svg
// module chunks = styles